export const styles = {
  // Input fields
  input: {
    width: '100%',
    padding: '12px 16px',
    marginBottom: '16px',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '14px',
    fontFamily: 'inherit',
    boxSizing: 'border-box',
    transition: 'border-color 0.3s',
  },
  
  inputFocus: {
    borderColor: '#F9C80E', // Yellow accent
    outline: 'none',
  },
  
  // Button
  button: {
    width: '100%',
    padding: '14px',
    backgroundColor: '#F9C80E', // Yellow button
    color: '#333',
    border: 'none',
    borderRadius: '25px', // Rounded button like in design
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'all 0.3s',
    marginTop: '10px',
    marginBottom: '10px',
    textTransform: 'none',
  },
  
  buttonHover: {
    backgroundColor: '#e6b800',
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
  },
  
  // Link
  link: {
    fontSize: '12px',
    color: '#666',
    textDecoration: 'none',
    textAlign: 'center',
    display: 'block',
    marginTop: '16px',
    transition: 'color 0.3s',
  },
  
  linkHover: {
    color: '#333',
    textDecoration: 'underline',
  },
  
  // Form container
  form: {
    width: '100%',
  },
  
  // Title
  title: {
    textAlign: 'center',
    marginBottom: '8px',
    fontSize: '18px',
    fontWeight: '600',
    color: '#333',
  },
  
  // Subtitle  
  subtitle: {
    textAlign: 'center',
    marginBottom: '24px',
    fontSize: '14px',
    color: '#666',
  },
};
